<template>
    <div>
        <h4 class="heading-1 mb-4">
            <span>COMPROMETIMENTOS COM ERRO</span>
            <div class="float-right">
                <span class="text-primary">
                    <i
                        class="fa fa-refresh fa-lg icon-button"
                        title="Atualizar"
                        @click.stop="$emit('atualizar-listagem')"
                    ></i>
                </span>
            </div>
        </h4>
        <painel-erros-dotacoes
            :dotacoes="dadosPainel ? dadosPainel.rateios : []"
        ></painel-erros-dotacoes>
        <etapas
            :etapas="dadosPainel ? dadosPainel.etapas : []"
            :servicos="servicos"
            :permiteAcessoErroComprometimento="permiteAcessoErroComprometimentoEtapa"
            tipo="2"
        >
            <template slot="etapaAcoes" slot-scope="data">
                <slot name="etapaAcoes" v-bind="data"></slot>
            </template>
        </etapas>
        <despesas
            :servicos="servicos2"
            :despesas="dadosPainel ? dadosPainel.despesas : []"
            :permiteAcessoErroComprometimento="permiteAcessoErroComprometimentoDespesa"
            :subTitulo="'Despesas'"
        >
            <template slot="despesaAcoes" slot-scope="data">
                <slot name="despesaAcoes" v-bind="data"></slot>
            </template>
        </despesas>
    </div>
</template>

<script>
import PainelErrosDotacoes from './PainelErrosDotacoes'
import Etapas from '../etapas/Etapas2'
import Despesas from './../despesas/Despesas2'

export default {
    props: {
        dadosPainel: {
            type: Object,
            default: () => {}
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        servicos2: {
            type: Object,
            default: () => ({})
        },

        permiteAcessoErroComprometimentoEtapa: {
            type: Boolean,
            default: () => false
        },

        permiteAcessoErroComprometimentoDespesa: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            tabIndex: 0
        }
    },

    methods: {},

    computed: {},

    created() {},

    watch: {},

    components: {
        PainelErrosDotacoes,
        Etapas,
        Despesas
    }
}
</script>
